import { useMemo } from 'react';

export const CHECKOUT_TASKS = [
  {
    id: 'CT-1001',
    listing: 'Canyon Views & Central Location',
    reservationId: 'HMHWNBX8NP',
    guest: 'Giuseppe',
    dueAt: '2026-03-28 11:00',
    assignee: 'Anna',
    status: 'Pending',
    priority: 'High',
    completedMinutes: null
  },
  {
    id: 'CT-1002',
    listing: 'Seaside View Apartment',
    reservationId: 'HAB2CD3E4F',
    guest: 'Maria',
    dueAt: '2026-03-27 10:30',
    assignee: 'Jason',
    status: 'Overdue',
    priority: 'Critical',
    completedMinutes: null
  },
  {
    id: 'CT-1003',
    listing: 'City Central Studio',
    reservationId: 'HXY9ZKW7MN',
    guest: 'John',
    dueAt: '2026-03-27 09:30',
    assignee: 'Nora',
    status: 'Done',
    priority: 'Medium',
    completedMinutes: 36
  },
  {
    id: 'CT-1004',
    listing: 'Lakefront Retreat',
    reservationId: 'HLK9PQ21TT',
    guest: 'Alicia',
    dueAt: '2026-03-28 12:00',
    assignee: 'Megan',
    status: 'In Progress',
    priority: 'Medium',
    completedMinutes: null
  },
  {
    id: 'CT-1005',
    listing: 'Mountain Escape',
    reservationId: 'HMN3TR88PK',
    guest: 'Omar',
    dueAt: '2026-03-27 08:45',
    assignee: 'Jason',
    status: 'Done',
    priority: 'Low',
    completedMinutes: 52
  }
];

export const HOST_NOTIFICATIONS_SEED = [
  {
    id: 'HN-1',
    severity: 'Critical',
    category: 'Policy',
    title: 'Repeated review concern detected',
    message: 'Two listings have repeated cleanliness complaints in the last 7 days.',
    listing: 'Seaside View Apartment',
    createdAt: '2026-03-27 09:10',
    read: false
  },
  {
    id: 'HN-2',
    severity: 'Warning',
    category: 'Performance',
    title: 'Response time above target',
    message: 'Average response time increased from 12m to 38m this week.',
    listing: 'Canyon Views & Central Location',
    createdAt: '2026-03-27 07:40',
    read: false
  },
  {
    id: 'HN-3',
    severity: 'Info',
    category: 'Review',
    title: 'New 5-star review trend',
    message: '5-star review share improved by 6.2% month-over-month.',
    listing: 'City Central Studio',
    createdAt: '2026-03-26 18:25',
    read: true
  },
  {
    id: 'HN-4',
    severity: 'Info',
    category: 'Policy',
    title: 'Ground rules reminder',
    message: 'Update house manual to reflect quiet hours after 10 PM.',
    listing: 'Mountain Escape',
    createdAt: '2026-03-26 10:12',
    read: true
  }
];

export const GROUND_RULE_NOTIFICATIONS = [
  {
    id: 'GR-501',
    rule: 'No parties or events',
    listing: 'Seaside View Apartment',
    reservationId: 'HAB2CD3E4F',
    triggerReason: 'Noise monitor spike after midnight',
    detectedAt: '2026-03-27 01:12',
    state: 'New',
    details: 'Noise threshold exceeded for 28 minutes. Neighbour complaint submitted.'
  },
  {
    id: 'GR-502',
    rule: 'No smoking indoors',
    listing: 'Lakefront Retreat',
    reservationId: 'HLK9PQ21TT',
    triggerReason: 'Housekeeping smell report',
    detectedAt: '2026-03-26 11:20',
    state: 'Acknowledged',
    details: 'Housekeeping tagged with photo evidence and incident note.'
  },
  {
    id: 'GR-503',
    rule: 'Check-out by 11:00 AM',
    listing: 'City Central Studio',
    reservationId: 'HXY9ZKW7MN',
    triggerReason: 'Late departure logged at 11:47 AM',
    detectedAt: '2026-03-25 11:47',
    state: 'Resolved',
    details: 'Guest paid late check-out fee. Unit prepared by 12:25 PM.'
  },
  {
    id: 'GR-504',
    rule: 'Maximum guest count: 4',
    listing: 'Canyon Views & Central Location',
    reservationId: 'HMHWNBX8NP',
    triggerReason: 'Smart lock showed 6 unique entries',
    detectedAt: '2026-03-24 20:35',
    state: 'Escalated',
    details: 'Escalated to host support due to repeated over-occupancy pattern.'
  }
];

export const STATUS_COLOR = {
  Pending: 'gold',
  'In Progress': 'blue',
  Done: 'green',
  Overdue: 'red',
  New: 'red',
  Acknowledged: 'orange',
  Resolved: 'green',
  Escalated: 'magenta'
};
export const SEVERITY_COLOR = { Critical: 'red', Warning: 'orange', Info: 'blue' };

const DUMMY_AIRBNB_ACCOUNTS = [{ airbnbUserId: 'acc-1001', nickname: 'KL Premium Host' }];
const DUMMY_COUNTRIES = [{ iso2: 'MY', name: 'Malaysia' }, { iso2: 'SG', name: 'Singapore' }];
const DUMMY_STATES_MY = [
  { code: '06', label: 'Pahang' },
  { code: '10', label: 'Selangor' },
  { code: '14', label: 'Kuala Lumpur' },
  { code: '12', label: 'Sabah' }
];

const DUMMY_LISTINGS = [
  {
    id: 100001,
    name: 'Canyon Views & Central Location',
    country: 'MY',
    state: 'Pahang',
    city: 'Genting Highlands',
    quality_state: 'GOOD',
    quality_state_label: 'Good',
    quality_status_family: 'good',
    average_review_score: { value: 4.92, reviews_count: 148 },
    airbnb_review_issues_count: 1,
    airbnb_cs_violations_count: 0,
    airbnb_issues_detail: {
      items: [{ reservation_id: 'HMHWNBX8NP', _id: '66f111111111111111111111', type: 'REVIEW_ISSUE', label: 'Late check-in instructions' }]
    }
  },
  {
    id: 100002,
    name: 'Seaside View Apartment',
    country: 'MY',
    state: 'Selangor',
    city: 'Petaling Jaya',
    quality_state: 'WARN',
    quality_state_label: 'Warn',
    quality_status_family: 'warning',
    average_review_score: { value: 4.41, reviews_count: 96 },
    airbnb_review_issues_count: 4,
    airbnb_cs_violations_count: 2,
    airbnb_issues_detail: {
      items: [
        { reservation_id: 'HAB2CD3E4F', _id: '66f222222222222222222222', type: 'REVIEW_ISSUE', label: 'Noise complaint' },
        { reservation_id: 'HAB2CD3E4F', _id: '66f222222222222222222222', type: 'CS_VIOLATION', label: 'Smoking in unit' }
      ]
    }
  },
  {
    id: 100003,
    name: 'City Central Studio',
    country: 'MY',
    state: 'Kuala Lumpur',
    city: 'Kuala Lumpur',
    quality_state: 'PROBATION',
    quality_state_label: 'Probation',
    quality_status_family: 'at_risk',
    average_review_score: { value: 4.06, reviews_count: 74 },
    airbnb_review_issues_count: 6,
    airbnb_cs_violations_count: 3,
    airbnb_issues_detail: {
      items: [{ reservation_id: 'HXY9ZKW7MN', _id: '66f333333333333333333333', type: 'CS_VIOLATION', label: 'Late checkout breach' }]
    }
  },
  {
    id: 100004,
    name: 'Lakefront Retreat',
    country: 'MY',
    state: 'Selangor',
    city: 'Shah Alam',
    quality_state: 'EDUCATE',
    quality_state_label: 'Educate',
    quality_status_family: 'good',
    average_review_score: { value: 4.77, reviews_count: 58 },
    airbnb_review_issues_count: 1,
    airbnb_cs_violations_count: 0,
    airbnb_issues_detail: { items: [] }
  },
  {
    id: 100005,
    name: 'Mountain Escape',
    country: 'MY',
    state: 'Sabah',
    city: 'Kota Kinabalu',
    quality_state: 'REMOVED',
    quality_state_label: 'Removed',
    quality_status_family: 'suspended',
    average_review_score: { value: 3.82, reviews_count: 31 },
    airbnb_review_issues_count: 8,
    airbnb_cs_violations_count: 5,
    airbnb_issues_detail: {
      items: [{ reservation_id: 'HMN3TR88PK', _id: '66f444444444444444444444', type: 'CS_VIOLATION', label: 'Repeated occupancy violation' }]
    }
  },
  {
    id: 100006,
    name: 'River Walk Loft',
    country: 'SG',
    state: 'Central',
    city: 'Singapore',
    quality_state: 'SUSPEND',
    quality_state_label: 'Suspend',
    quality_status_family: 'suspended',
    average_review_score: { value: 4.12, reviews_count: 44 },
    airbnb_review_issues_count: 3,
    airbnb_cs_violations_count: 1,
    airbnb_issues_detail: { items: [] }
  }
];

const DUMMY_REVIEW_TRENDS_MONTH = {
  series: [
    {
      period_key: '2025-10',
      avg_overall_rating: 4.53,
      yoy_avg_overall_rating: 4.35,
      five_star_percentage: 74,
      yoy_five_star_percentage: 68,
      is_complete_period: true
    },
    {
      period_key: '2025-11',
      avg_overall_rating: 4.58,
      yoy_avg_overall_rating: 4.37,
      five_star_percentage: 76,
      yoy_five_star_percentage: 69,
      is_complete_period: true
    },
    {
      period_key: '2025-12',
      avg_overall_rating: 4.64,
      yoy_avg_overall_rating: 4.42,
      five_star_percentage: 80,
      yoy_five_star_percentage: 72,
      is_complete_period: true
    },
    {
      period_key: '2026-01',
      avg_overall_rating: 4.68,
      yoy_avg_overall_rating: 4.48,
      five_star_percentage: 82,
      yoy_five_star_percentage: 74,
      is_complete_period: true
    },
    {
      period_key: '2026-02',
      avg_overall_rating: 4.71,
      yoy_avg_overall_rating: 4.5,
      five_star_percentage: 84,
      yoy_five_star_percentage: 75,
      is_complete_period: true
    },
    {
      period_key: '2026-03',
      avg_overall_rating: 4.69,
      yoy_avg_overall_rating: null,
      five_star_percentage: 83,
      yoy_five_star_percentage: null,
      is_complete_period: false
    }
  ]
};
const DUMMY_REVIEW_TRENDS_WEEK = {
  series: [
    {
      period_key: '2026-W08',
      avg_overall_rating: 4.61,
      yoy_avg_overall_rating: 4.41,
      five_star_percentage: 79,
      yoy_five_star_percentage: 72,
      is_complete_period: true
    },
    {
      period_key: '2026-W09',
      avg_overall_rating: 4.66,
      yoy_avg_overall_rating: 4.44,
      five_star_percentage: 81,
      yoy_five_star_percentage: 73,
      is_complete_period: true
    },
    {
      period_key: '2026-W10',
      avg_overall_rating: 4.72,
      yoy_avg_overall_rating: 4.5,
      five_star_percentage: 85,
      yoy_five_star_percentage: 76,
      is_complete_period: true
    },
    {
      period_key: '2026-W11',
      avg_overall_rating: 4.7,
      yoy_avg_overall_rating: 4.47,
      five_star_percentage: 84,
      yoy_five_star_percentage: 75,
      is_complete_period: true
    },
    {
      period_key: '2026-W12',
      avg_overall_rating: null,
      yoy_avg_overall_rating: null,
      five_star_percentage: null,
      yoy_five_star_percentage: null,
      is_complete_period: false
    }
  ]
};
const DUMMY_COMPONENT_EVOLUTION = {
  series: [
    {
      period_key: '2026-01',
      categories: [
        { category: 'cleanliness', avg_rating: 4.82 },
        { category: 'accuracy', avg_rating: 4.7 },
        { category: 'communication', avg_rating: 4.86 },
        { category: 'check_in', avg_rating: 4.83 },
        { category: 'location', avg_rating: 4.74 },
        { category: 'value', avg_rating: 4.63 }
      ],
      yoy_categories: [
        { category: 'cleanliness', avg_rating: 4.64 },
        { category: 'accuracy', avg_rating: 4.53 },
        { category: 'communication', avg_rating: 4.69 },
        { category: 'check_in', avg_rating: 4.67 },
        { category: 'location', avg_rating: 4.61 },
        { category: 'value', avg_rating: 4.49 }
      ],
      is_complete_period: true
    },
    {
      period_key: '2026-02',
      categories: [
        { category: 'cleanliness', avg_rating: 4.85 },
        { category: 'accuracy', avg_rating: 4.72 },
        { category: 'communication', avg_rating: 4.88 },
        { category: 'check_in', avg_rating: 4.84 },
        { category: 'location', avg_rating: 4.76 },
        { category: 'value', avg_rating: 4.65 }
      ],
      yoy_categories: [
        { category: 'cleanliness', avg_rating: 4.66 },
        { category: 'accuracy', avg_rating: 4.54 },
        { category: 'communication', avg_rating: 4.7 },
        { category: 'check_in', avg_rating: 4.69 },
        { category: 'location', avg_rating: 4.63 },
        { category: 'value', avg_rating: 4.51 }
      ],
      is_complete_period: true
    },
    {
      period_key: '2026-03',
      categories: [
        { category: 'cleanliness', avg_rating: null },
        { category: 'accuracy', avg_rating: null },
        { category: 'communication', avg_rating: null },
        { category: 'check_in', avg_rating: null },
        { category: 'location', avg_rating: null },
        { category: 'value', avg_rating: null }
      ],
      yoy_categories: [],
      is_complete_period: false
    }
  ]
};
const DUMMY_REVIEW_SUMMARY = {
  overall: { avg_rating: 4.69 },
  categories: [
    { category: 'cleanliness', avg_rating: 4.79, positive_percentage: 96, negative_percentage: 4 },
    { category: 'arrival', avg_rating: 4.72, positive_percentage: 94, negative_percentage: 6 },
    { category: 'accuracy', avg_rating: 4.64, positive_percentage: 91, negative_percentage: 9 },
    { category: 'communication', avg_rating: 4.81, positive_percentage: 97, negative_percentage: 3 },
    { category: 'location', avg_rating: 4.61, positive_percentage: 89, negative_percentage: 11 },
    { category: 'quality', avg_rating: 4.56, positive_percentage: 87, negative_percentage: 13 }
  ]
};
const DUMMY_REVIEW_TAGS = {
  categories: [
    {
      category: 'cleanliness',
      total_count: 133,
      positive: [{ label: 'Spotless room', count: 71 }],
      negative: [{ label: 'Dusty corners', count: 12 }]
    },
    {
      category: 'arrival',
      total_count: 102,
      positive: [{ label: 'Easy self check-in', count: 54 }],
      negative: [{ label: 'Late key handoff', count: 10 }]
    },
    {
      category: 'accuracy',
      total_count: 88,
      positive: [{ label: 'Matches photos', count: 46 }],
      negative: [{ label: 'Missing amenities', count: 11 }]
    },
    {
      category: 'communication',
      total_count: 121,
      positive: [{ label: 'Fast response', count: 78 }],
      negative: [{ label: 'Slow replies', count: 7 }]
    },
    { category: 'location', total_count: 96, positive: [{ label: 'Great location', count: 61 }], negative: [{ label: 'Noisy street', count: 9 }] },
    { category: 'quality', total_count: 79, positive: [{ label: 'Great value', count: 43 }], negative: [{ label: 'Overpriced', count: 10 }] }
  ]
};
const DUMMY_REVIEW_VIOLATIONS = {
  total_violations: 15,
  categories: [
    { category: 'cleanliness', label: 'Cleanliness', count: 2 },
    { category: 'arrival', label: 'Arrival', count: 3 },
    { category: 'accuracy', label: 'Accuracy', count: 2 },
    { category: 'communication', label: 'Communication', count: 1 },
    { category: 'location', label: 'Location', count: 4 },
    { category: 'quality', label: 'Quality', count: 3 }
  ]
};
const DUMMY_ACCOMMODATION_STATUS = {
  statuses: [
    { state: 'GOOD', label: 'Good', count: 2 },
    { state: 'WARN', label: 'Warn', count: 1 },
    { state: 'PROBATION', label: 'Probation', count: 1 },
    { state: 'SUSPEND', label: 'Suspend', count: 1 },
    { state: 'REMOVED', label: 'Removed', count: 1 }
  ]
};
const DUMMY_DETAILED_REVIEWS = [
  {
    dateOfReception: '2026-03-25',
    hostIdName: 'acc-1001 / KL Premium Host',
    listingIdName: '100001 / Canyon Views & Central Location',
    airbnbResId: 'HMHWNBX8NP',
    guestName: 'Giuseppe',
    publicReview: 'Lovely stay and responsive host.',
    privateReview: 'Could improve parking instructions.',
    overallRating: 5,
    locationRating: 5,
    commRating: 5,
    valueRating: 4,
    checkinRating: 5,
    accuracyRating: 5,
    cleanlinessRating: 5,
    negativeTags: 'Parking instruction',
    qualityStatus: 'Good'
  }
];

const byListingId = DUMMY_LISTINGS.reduce((acc, row) => ({ ...acc, [String(row.id)]: row }), {});

function applyListingFilters(rows, query = {}) {
  const listingText = String(query.listing || '')
    .trim()
    .toLowerCase();
  const cityText = String(query.city || '')
    .trim()
    .toLowerCase();
  const countryText = String(query.country || '').trim();
  const stateText = String(query.state || '')
    .trim()
    .toLowerCase();
  const familyFilter = String(query.kpiStatus || query.quality_status || '')
    .trim()
    .toLowerCase();
  return rows.filter(item => {
    const listingRef = `${item.id} ${item.name}`.toLowerCase();
    if (listingText && !listingRef.includes(listingText)) return false;
    if (
      cityText &&
      !String(item.city || '')
        .toLowerCase()
        .includes(cityText)
    )
      return false;
    if (countryText && String(item.country || '') !== countryText) return false;
    if (stateText && String(item.state || '').toLowerCase() !== stateText) return false;
    if (familyFilter && String(item.quality_status_family || '').toLowerCase() !== familyFilter) return false;
    return true;
  });
}

function buildLatestData(filteredRows) {
  const total = filteredRows.length;
  const familyCount = { good: 0, warning: 0, at_risk: 0, suspended: 0 };
  filteredRows.forEach(item => {
    const key = String(item.quality_status_family || '').toLowerCase();
    if (familyCount[key] != null) familyCount[key] += 1;
  });
  const toMetric = count => ({ count, total, percentage: total ? Math.round((count / total) * 100) : 0, label: '' });
  return {
    total_listings: total,
    metrics: {
      good: toMetric(familyCount.good),
      warning: toMetric(familyCount.warning),
      at_risk: toMetric(familyCount.at_risk),
      suspended: toMetric(familyCount.suspended)
    },
    totalCount: total
  };
}

export function useGetPaginatedAirbnbQualityDashboard(query) {
  const filtered = useMemo(() => applyListingFilters(DUMMY_LISTINGS, query), [query]);
  const currentPage = Number(query && query.currentPage ? query.currentPage : 1);
  const limit = Number(query && query.limit ? query.limit : 10);
  const start = Math.max(0, (currentPage - 1) * limit);
  const paginatedData = useMemo(() => filtered.slice(start, start + limit), [filtered, start, limit]);
  const latestData = useMemo(() => buildLatestData(filtered), [filtered]);

  return {
    isLoading: false,
    paginatedData,
    total: filtered.length,
    latestData,
    error: null
  };
}

const asResponse = data => Promise.resolve({ data });

export const getAirbnbQualityDashboardAccounts = () => asResponse(DUMMY_AIRBNB_ACCOUNTS);
export const getCountriesConstant = () => Promise.resolve(DUMMY_COUNTRIES);
export const getStatesConstant = countryIso => Promise.resolve(String(countryIso) === 'MY' ? DUMMY_STATES_MY : []);
export const getReviewTrends = query =>
  asResponse(String(query && query.granularity) === 'week' ? DUMMY_REVIEW_TRENDS_WEEK : DUMMY_REVIEW_TRENDS_MONTH);
export const getComponentEvolution = () => asResponse(DUMMY_COMPONENT_EVOLUTION);
export const getReviewQualitySummary = () => asResponse(DUMMY_REVIEW_SUMMARY);
export const getReviewQualityTags = () => asResponse(DUMMY_REVIEW_TAGS);
export const getReviewQualityViolations = () => asResponse(DUMMY_REVIEW_VIOLATIONS);
export const getReviewQualityAccommodationStatus = () => asResponse(DUMMY_ACCOMMODATION_STATUS);
export const getQualityDashboardDetailedReviewsReport = () => asResponse(DUMMY_DETAILED_REVIEWS);
export const getQualityDashboardListingIssues = listingId => {
  const listing = byListingId[String(listingId)];
  const items =
    listing && listing.airbnb_issues_detail && Array.isArray(listing.airbnb_issues_detail.items) ? listing.airbnb_issues_detail.items : [];
  return asResponse(items);
};
